exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.text-inside-grid {\r\n    position: absolute;\r\n    left: 0px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Dev/Angular/liceo/src/app/case-schedule/case-schedule.component.css
// module id = ../../../../../src/app/case-schedule/case-schedule.component.css
// module chunks = main